/**
 * Редактор и просмотр описания грузятся отдельно, по первому появлению.
 *
 * ProseMirror, грамматики подсветки и набор эмодзи — около половины
 * мегабайта: в общем пакете интерфейса они замедлили бы вход и доску,
 * где описания не видно. Пока модуль грузится, на месте поля — заглушка
 * той же высоты, чтобы форма не прыгала.
 */

import { lazy, Suspense } from "react";

import { cn } from "../cn";
import type { RichTextEditorProps } from "./RichTextEditor";
import type { RichTextViewProps } from "./RichTextView";

const EditorImpl = lazy(() =>
  import("./RichTextEditor").then((module) => ({ default: module.RichTextEditor })),
);
const ViewImpl = lazy(() =>
  import("./RichTextView").then((module) => ({ default: module.RichTextView })),
);

export function RichTextEditor(props: RichTextEditorProps) {
  return (
    <Suspense
      fallback={
        <div
          aria-busy="true"
          className={cn(
            "tf-rich tf-rich--edit",
            props.size === "sm" ? "min-h-[6.5rem]" : "min-h-[10.5rem]",
          )}
        />
      }
    >
      <EditorImpl {...props} />
    </Suspense>
  );
}

export function RichTextView(props: RichTextViewProps) {
  return (
    <Suspense fallback={<div aria-busy="true" className="min-h-5" />}>
      <ViewImpl {...props} />
    </Suspense>
  );
}
